/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable object-curly-newline */
import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Box } from '@mui/material';
import DataTable from '../../components/DataTable';
import StatusPill from '../../components/StatusPill';
import { convertSecToTimeFormat } from '../../utils/time';

const perfTone = (pct) => {
  if (pct >= 80) return 'success';
  if (pct >= 50) return 'warning';
  return 'error';
};

function SubordinatesModal({ closeModal, subordinates, expectedHours }) {
  const expectedHoursInHours = expectedHours / 3600;

  const rows = (subordinates.subordinates || []).map((s, idx) => {
    const active = s.dailyActivity?.activeSeconds || 0;
    const total = s.dailyActivity?.totalSeconds || 0;
    const pct = active ? Math.round((active / 28800) * 100) : 0;
    return {
      id: s.id ?? idx,
      name: `${s.user?.firstName || ''} ${s.user?.lastName || ''}`.trim() || s.user?.email || 'N/A',
      hoursWorked: convertSecToTimeFormat(active),
      idleTime: convertSecToTimeFormat(total ? total - active : 0),
      expectedHours: expectedHoursInHours,
      pct,
    };
  });

  const columns = [
    {
      key: 'name',
      label: 'Member',
      width: 220,
      flex: true,
      render: (r) => <span className="font-medium text-ink-900 truncate block" title={r.name}>{r.name}</span>,
    },
    {
      key: 'hoursWorked',
      label: 'Hours Worked',
      width: 130,
      render: (r) => <span className="tabular-nums text-ink-900">{r.hoursWorked}</span>,
    },
    {
      key: 'idleTime',
      label: 'Idle Time',
      width: 120,
      render: (r) => <span className="tabular-nums text-ink-700">{r.idleTime}</span>,
    },
    {
      key: 'expectedHours',
      label: 'Expected',
      width: 110,
      render: (r) => <span className="tabular-nums text-ink-700">{`${r.expectedHours}h`}</span>,
    },
    {
      key: 'pct',
      label: 'Performance',
      width: 130,
      render: (r) => <StatusPill tone={perfTone(r.pct)}>{`${r.pct}%`}</StatusPill>,
    },
  ];

  return (
    <Modal open onClose={closeModal} className="flex-row align-c jstfy-c" data-testid="subordinates-modal">
      <Box style={{ width: 860, maxWidth: 'calc(100% - 32px)', maxHeight: '88vh', overflowY: 'auto', padding: 24, background: '#fff', borderRadius: 12 }}>
        <div className="mb-4">
          <h5 className="text-lg font-semibold leading-none text-ink-900 mb-1">{`${subordinates.name}'s Team`}</h5>
          <p className="text-sm text-ink-500">Review every team member&apos;s performance and engagement</p>
        </div>
        <DataTable
          columns={columns}
          rows={rows}
          getRowKey={(r) => r.id}
          emptyText="No subordinates found."
          minWidth={720}
        />
        <div className="flex justify-start items-center gap-2 mt-6">
          <button
            type="button"
            onClick={closeModal}
            className="inline-flex items-center justify-center px-4 py-2 border border-rule rounded-[8px] text-sm font-medium text-ink-900 bg-white hover:bg-gray-50 transition"
            style={{ borderStyle: 'solid' }}
          >
            Close
          </button>
        </div>
      </Box>
    </Modal>
  );
}

SubordinatesModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  expectedHours: PropTypes.number.isRequired,
  subordinates: PropTypes.shape({
    name: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    subordinates: PropTypes.array,
  }).isRequired,
};

export default SubordinatesModal;
